import React from "react";
import { useSelector } from "react-redux";
import { OFFICE_TYPES } from "../../dto/Company/CompanySettingsDto";
import { AdminPanelCompanySettingsModel } from "../../viewModels/Settings/AdminPanelCompanySettingsModel";
import { CurrencyModel } from "../../viewModels/Settings/CurrencyModel";
import { makeSelectCurrencies, makeSelectBaseCompanyCurrency } from "../App/selectors";
import { LinkProps } from "react-router-dom";

type ApplicationViewSettings = AdminPanelCompanySettingsModel & {
  officeType: OFFICE_TYPES;
  baseCurrency: CurrencyModel;
  getDealLink: (id: number) => Pick<LinkProps, "to" | "state" | "replace">;
};
export const ApplicationViewContext = React.createContext<ApplicationViewSettings | undefined>(undefined);
export const useApplicationViewSettings = () => React.useContext(ApplicationViewContext);
export function useApplicationCurrencies() {
  const settings = useApplicationViewSettings();
  const currencies = useSelector(makeSelectCurrencies());
  return settings ? settings.currencies : currencies;
}
export function useApplicationBaseCurrency() {
  const settings = useApplicationViewSettings();
  const currency = useSelector(makeSelectBaseCompanyCurrency());
  return settings ? settings.baseCurrency : currency;
}
